import { render, staticRenderFns } from "./SitesTab.vue?vue&type=template&id=cb05962a"
import script from "./SitesTab.vue?vue&type=script&lang=js"
export * from "./SitesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports